export const localePickerUat = {
  button: 'layout.locale.button',
}
